export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10031.fc2fd88f.jpg";